/** @jsx jsx **/

import { Fragment } from 'react';

import { Margin, SkeletonLoader, SkeletonText } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import {
  PartnerTiersType,
  TierNames,
} from 'app/developer-v3/types/partnerDashboard';

import ProgressLine from './ProgressLine';
import Styles from './TierGraph.styles';
import Tier from './Tier';
import { PARTNER_TIERS } from './constants';

const TIER_NAMES: TierNames = PARTNER_TIERS.reduce(
  (names, tier) => ({ ...names, [tier.key]: tier.key }),
  {}
);

type Props = {
  status: {
    deadline: string;
    tier: PartnerTiersType;
  };
};

const TierGraph = (props: Props) => {
  const { status } = props;

  if (!status || !status.tier) {
    return (
      <Margin margin="0px 0px 20px 0px">
        <SkeletonLoader>
          <SkeletonText lines={3} size="body" />
        </SkeletonLoader>
      </Margin>
    );
  }

  const partnerTiersClean = PARTNER_TIERS.filter(
    tier => tier.key !== TIER_NAMES.BETA
  );

  const lastPartnerTiersIndex = partnerTiersClean.length - 1;

  const completedIndex = partnerTiersClean.findIndex(
    tier => tier.key === status.tier
  );

  return (
    <div css={[Styles.tierGraph, Styles.progressBar(completedIndex)]}>
      {partnerTiersClean.map((tier, i) => {
        const isActive = i === completedIndex;
        const isCompleted = i < completedIndex;

        const tooltipClassName = {
          [0]: 'first',
          [lastPartnerTiersIndex]: 'last',
        }[i];

        return (
          <Fragment key={tier.key}>
            <Tier
              isActive={isActive}
              isCompleted={isCompleted}
              tier={tier}
              tooltipClassName={tooltipClassName}
            />
            {i !== lastPartnerTiersIndex && (
              <ProgressLine
                index={i}
                isCompleted={isCompleted}
                key={`${tier.key}-sep`}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default TierGraph;
